var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonOnDesk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 563,
    height: 512,
    viewBox: "0 0 563 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456.272 224.811H449.274V472.305H456.272V224.811Z",
    fill: "#1F1E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.702 224.811H107.704V472.305H114.702V224.811Z",
    fill: "#1F1E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M279.555 442.473C279.555 442.473 270.027 467.611 276.092 470.861C282.153 474.112 338.67 470.861 338.67 470.861C338.67 470.861 343.651 461.038 328.493 457.389C313.334 453.74 306.405 444.638 306.405 444.638L279.555 442.473Z",
    fill: "#FFB300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.159 442.473C181.159 442.473 171.632 467.611 177.696 470.861C183.757 474.112 240.274 470.861 240.274 470.861C240.274 470.861 245.255 461.038 230.097 457.389C214.939 453.74 208.009 444.638 208.009 444.638L181.159 442.473Z",
    fill: "#FFB300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M561.048 223.955H1.95219C0.874027 223.955 0 224.83 0 225.909V228.229C0 229.308 0.874027 230.183 1.95219 230.183H561.048C562.126 230.183 563 229.308 563 228.229V225.909C563 224.83 562.126 223.955 561.048 223.955Z",
    fill: "#1F1E2E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.51
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M561.044 223.955H1.95219C0.872028 223.955 0 224.831 0 225.909V227.64C0 226.559 0.875617 225.686 1.95219 225.686H561.044C562.124 225.686 562.996 226.563 562.996 227.64V225.909C562.996 224.828 562.121 223.955 561.044 223.955Z",
    fill: "#33226C"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M545.312 224.811H538.314V472.305H545.312V224.811Z",
    fill: "#1F1E2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M368.488 149.316C368.488 149.316 385.698 178.175 385.698 196.637C385.698 207.11 373.515 218.682 373.515 218.682L305.109 218.585C305.109 218.585 345.054 207.387 334.999 182.827C324.94 158.267 318.721 149.316 318.721 149.316H368.488Z",
    fill: "#471F5E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M242.112 270.184C242.112 270.184 317.275 275.399 344.487 299.265C353.039 312.238 357.704 313.273 308.974 445.066C308.974 445.066 289.793 454.404 276.831 442.472C291.864 389.028 299.124 336.105 299.124 336.105C299.124 336.105 242.097 342.333 228.618 335.067C215.14 327.805 218.276 284.166 242.112 270.184Z",
    fill: "#31236C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.766 270.184C143.766 270.184 218.929 275.399 246.142 299.265C254.693 312.238 259.358 313.273 210.629 445.066C210.629 445.066 191.448 454.404 178.486 442.472C193.518 389.028 200.778 336.105 200.778 336.105C200.778 336.105 160.475 338.027 146.842 331.062C122.468 318.61 119.934 284.166 143.766 270.184Z",
    fill: "#31236C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.766 270.184C143.766 270.184 218.929 275.399 246.142 299.265C254.693 312.238 259.358 313.273 210.629 445.066C210.629 445.066 191.448 454.404 178.486 442.472C193.518 389.028 200.778 336.105 200.778 336.105C200.778 336.105 160.475 338.027 146.842 331.062C122.468 318.61 119.934 284.166 143.766 270.184Z",
    fill: "#31236C"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6621 224.811H18.6643V472.305H25.6621V224.811Z",
    fill: "#1F1E2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M335.429 195.212C335.429 195.212 349.762 189.918 356.929 194.199C364.963 198.997 368.592 205.495 370.537 215.99C372.094 224.394 360.815 210.541 358.482 209.503C356.15 208.465 351.23 218.583 344.487 215.99C337.744 213.396 334.374 196.638 334.374 196.638",
    fill: "#FBB1A6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M544.034 154.549H485.648L456.272 223.814H514.658L544.034 154.549Z",
    fill: "#F1F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.46
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M521.34 154.549H485.633L461.938 210.417C467.533 213.334 473.795 214.968 480.412 214.968C504.068 214.968 523.242 194.086 523.242 168.33C523.242 163.532 522.574 158.906 521.34 154.549Z",
    fill: "#F1F2F2"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M544.034 154.549L553.666 223.814H514.658L544.034 154.549Z",
    fill: "#D1D3D4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M525.309 181.703H484.029C483.225 181.703 482.68 180.881 482.996 180.141C483.172 179.724 483.581 179.455 484.029 179.455H525.309C526.113 179.455 526.658 180.278 526.342 181.017C526.167 181.434 525.757 181.703 525.309 181.703Z",
    fill: "#D1D3D4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M522.137 189.182H480.857C480.053 189.182 479.508 188.359 479.823 187.62C479.999 187.203 480.408 186.934 480.857 186.934H522.137C522.94 186.934 523.486 187.756 523.17 188.496C522.994 188.913 522.589 189.182 522.137 189.182Z",
    fill: "#D1D3D4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M518.964 196.662H477.685C476.881 196.662 476.335 195.84 476.651 195.1C476.827 194.683 477.236 194.414 477.685 194.414H518.964C519.768 194.414 520.314 195.237 519.998 195.976C519.822 196.393 519.413 196.662 518.964 196.662Z",
    fill: "#D1D3D4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M500.813 202.994H475C474.197 202.994 473.651 202.172 473.967 201.432C474.143 201.015 474.552 200.746 475 200.746H500.813C501.617 200.746 502.163 201.569 501.847 202.308C501.671 202.725 501.262 202.994 500.813 202.994Z",
    fill: "#D1D3D4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M509.978 217.85H484.166C483.362 217.85 482.816 217.027 483.132 216.288C483.308 215.871 483.714 215.602 484.166 215.602H509.978C510.782 215.602 511.328 216.424 511.012 217.164C510.836 217.581 510.427 217.85 509.978 217.85Z",
    fill: "#D1D3D4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M494.871 162.404L490.349 173.068H487.884L492.405 162.404H494.871Z",
    fill: "#D1D3D4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M497.781 162.404L496.927 164.412H497.867H501.398L493.909 173.068H496.589L504.391 164.003L505.069 162.404H497.781Z",
    fill: "#D1D3D4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3329 187.548C76.4406 185.529 74.8365 183.834 72.8161 183.834H34.3248C32.3045 183.834 30.704 185.529 30.808 187.548C31.1992 194.979 33.2231 212 43.3394 223.957H63.8051C73.9214 212 75.9453 194.979 76.3365 187.548H76.3329Z",
    fill: "#FFB300"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4699 183.834C47.4699 183.834 26.9001 158.664 30.8045 103.715C62.5958 136.985 53.5705 183.834 53.5705 183.834H47.4663H47.4699Z",
    fill: "url(#paint0_linear_2862_11635)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19,
    d: "M30.8045 103.715C30.8009 103.779 30.7973 103.844 30.7937 103.909C55.6806 135.426 48.69 174.521 46.7988 182.936C47.2259 183.536 47.4699 183.834 47.4699 183.834H53.5741C53.5741 183.834 62.5958 136.985 30.8045 103.715Z",
    fill: "url(#paint1_linear_2862_11635)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6963 76.6758C68.6963 76.6758 39.5713 108.573 53.574 183.833H57.4497C57.4497 183.833 78.4071 127.139 68.6963 76.6758Z",
    fill: "url(#paint2_linear_2862_11635)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4851 118.709C89.4851 118.709 65.2513 136.484 57.4497 183.833H60.5144C60.5144 183.833 91.9756 152.018 89.4851 118.709Z",
    fill: "url(#paint3_linear_2862_11635)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.52
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4499 223.956H63.8053C66.0984 221.244 67.9753 218.27 69.5112 215.207C46.1494 213.307 43.8312 196.472 43.8671 189.602C43.8743 188 42.5716 186.703 40.9711 186.703H30.8692C30.819 186.976 30.7939 187.256 30.8082 187.547C31.1994 194.978 33.2233 211.999 43.3396 223.956H57.4499Z",
    fill: "#FFB300"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M197.663 153.354L219.195 0H488.099L466.567 153.354H197.663Z",
    fill: "#471F5E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M463.101 149.317H202.26L222.661 4.03711H483.502L463.101 149.317Z",
    fill: "url(#paint4_linear_2862_11635)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M243.436 56.1625C243.436 56.1625 244.796 63.9205 241.663 74.5519C240.045 80.0399 240.325 85.9267 242.661 91.1454C242.679 91.1849 242.697 91.2208 242.711 91.2603C243.396 92.7724 242.844 94.5539 241.415 95.3979C241.06 95.6062 240.658 95.8146 240.199 96.0157C238.882 96.5904 237.902 97.7397 237.59 99.144L235.706 107.631L221.362 104.866L217.386 73.0434L229.311 50.9043L243.432 56.1625H243.436Z",
    fill: "#FBB1A6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M214.088 106.519C214.088 106.519 209.308 112.219 208.533 123.633L174.922 121.557L179.72 106.077L201.406 64.4821L214.092 63.1855C214.092 63.1855 217.706 80.0628 214.092 106.515L214.088 106.519Z",
    fill: "#FBB1A6"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.1,
    d: "M209.99 96.4724C234.148 118.303 273.034 132.468 316.891 132.468C390.173 132.468 449.582 92.9238 449.582 44.1417C449.582 29.7032 444.375 16.0728 435.146 4.03711H222.97L209.99 96.4724Z",
    fill: "url(#paint5_linear_2862_11635)"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M235.132 111.084C234.565 114.485 231.22 116.694 227.879 115.847C221.47 114.223 212.581 110.423 213.586 101.925C215.14 88.7799 217.042 66.9892 208.576 67.5064C200.107 68.0236 201.492 78.2312 205.293 86.1867C209.093 94.1423 193.023 107.977 179.717 106.077C179.717 106.077 180.668 97.6908 173.842 88.2627C164.544 75.4225 162.265 67.6824 161.745 60.5889C161.228 53.4989 164.164 44.157 173.494 41.219C176.401 32.66 191.667 19.0188 235.369 33.9961C236.707 34.4559 238.071 34.8294 239.47 35.0485C246.479 36.1403 251.259 33.9566 251.259 33.9566C251.259 33.9566 253.179 45.2812 247.541 52.8165C245.198 55.9484 241.369 57.615 237.479 57.2271C228.507 56.3363 224.09 60.8977 222.399 67.51C220.498 74.9484 217.734 99.6806 224.646 103.312C231.558 106.943 235.706 107.636 235.706 107.636L235.132 111.084Z",
    fill: "url(#paint6_linear_2862_11635)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M405.608 218.682H291.896V223.954H405.608V218.682Z",
    fill: "url(#paint7_linear_2862_11635)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.44,
    d: "M405.608 220.525H291.896V223.952H405.608V220.525Z",
    fill: "url(#paint8_linear_2862_11635)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M291.728 448.498C303.728 408.764 317.652 333.234 317.652 333.234L299.124 336.104C299.124 336.104 293.084 380.138 280.614 428.432C279.81 433.435 279.035 438.7 278.403 443.786C282.595 447.001 287.292 448.261 291.724 448.495L291.728 448.498Z",
    fill: "#31236C"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M248.367 335.853L241.656 338.076C239.592 338.762 238.516 341.032 239.291 343.065L294.383 487.486C295.011 489.128 296.676 490.13 298.42 489.914C300.807 489.616 302.328 487.213 301.575 484.925L253.193 338.277C252.533 336.273 250.373 335.185 248.37 335.849L248.367 335.853Z",
    fill: "url(#paint9_linear_2862_11635)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M192.442 333.308L199.375 334.687C201.507 335.111 202.856 337.23 202.336 339.346L165.459 489.467C165.039 491.173 163.511 492.376 161.752 492.376C159.348 492.376 157.543 490.178 158.009 487.815L187.953 336.318C188.362 334.249 190.371 332.902 192.438 333.312L192.442 333.308Z",
    fill: "url(#paint10_linear_2862_11635)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M148.051 335.034L155.687 337.132C158.038 337.778 159.373 340.253 158.623 342.573L105.411 507.341C104.805 509.216 103 510.434 101.037 510.294C98.3489 510.1 96.508 507.499 97.2185 504.899L142.797 338.037C143.422 335.756 145.772 334.413 148.051 335.038V335.034Z",
    fill: "url(#paint11_linear_2862_11635)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.26
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M200.437 123.133L208.533 123.632C209.312 112.218 214.088 106.518 214.088 106.518C214.357 104.553 214.583 102.642 214.777 100.789C211.652 102.438 201.647 109.247 200.437 123.136V123.133Z",
    fill: "#FBB1A6"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M161.688 122.879C161.688 122.879 139.453 123.138 119.235 163.608C99.0164 204.079 99.8023 207.887 99.8023 207.887C99.8023 207.887 89.1657 249.74 151.374 230.543L161.684 122.879H161.688Z",
    fill: "#EF305E"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33,
    d: "M158.863 163.6C156.125 153.644 153.879 146.975 153.879 146.975C153.879 146.975 99.4075 204.599 121.585 235.477C129.056 235.973 139.065 234.672 152.451 230.542L158.86 163.6H158.863Z",
    fill: "url(#paint12_linear_2862_11635)"
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M128.048 211.578C128.048 211.578 127.531 189.266 134.787 161.768C142.044 134.271 144.136 117.379 192.338 120.637C240.543 123.894 237.059 127.005 243.726 131.677C249.109 135.449 272.973 175.503 281.952 190.771C284.069 194.374 288.017 196.489 292.187 196.263C304.567 195.588 329.835 194.262 333.337 194.456C338.002 194.715 346.037 206.908 344.225 217.547C304.826 231.555 285.293 239.079 270.35 234.669C252.913 229.522 240.238 193.45 236.262 192.122C235.189 201.126 231.199 243.87 241.06 265.022C251.948 288.371 176.243 327.283 128.037 300.824C128.565 244.269 128.045 211.581 128.045 211.581L128.048 211.578Z",
    fill: "#EF305E"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33,
    d: "M342.517 206.057C337.744 209.042 287.31 239.589 266.205 211.681C244.042 182.37 234.83 152.268 215.692 173.656C196.554 195.045 194.85 253.665 195.305 256.042C195.614 257.641 204.733 283.264 210.672 299.861C231.848 290.411 245.754 276.059 240.651 265.118C230.789 243.967 234.78 201.223 235.853 192.218C239.829 193.544 252.504 229.618 269.941 234.765C284.884 239.176 304.417 231.651 343.816 217.644C344.476 213.768 343.827 209.692 342.513 206.057H342.517Z",
    fill: "url(#paint13_linear_2862_11635)"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M111.458 279.55C111.458 279.55 104.202 205.354 166.927 205.354C235.419 205.354 225.507 275.398 243.726 301.862C251.359 318.358 264.357 331.425 276.817 337.915C289.273 344.409 200.322 373.512 152.415 346.222C113.016 323.782 111.462 279.55 111.462 279.55H111.458Z",
    fill: "#362478"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M277.05 337.915C264.594 331.421 251.593 318.355 243.96 301.862C225.744 275.398 235.652 205.354 167.16 205.354C145.726 205.354 132.462 214.02 124.291 225.424C131.612 221.247 140.852 218.682 152.515 218.682C221.007 218.682 211.095 288.727 229.315 315.19C236.327 330.347 247.871 342.606 259.366 349.53C273.494 345.134 281.371 340.167 277.05 337.915Z",
    fill: "url(#paint14_linear_2862_11635)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M213.048 334.583C208.497 335.488 205.619 340.01 206.728 344.521L247.068 508.743C247.538 510.654 249.249 512 251.22 512C253.915 512 255.935 509.537 255.411 506.893L222.622 340.997C221.75 336.58 217.462 333.706 213.048 334.586V334.583Z",
    fill: "url(#paint15_linear_2862_11635)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M523.149 171.984H514.658L518.261 163.486H526.752L523.149 171.984Z",
    fill: "#FFB300"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M235.211 110.613L235.706 107.632C235.706 107.632 231.558 106.938 224.646 103.307C218.84 100.258 219.862 82.321 221.463 72.25C219.191 72.6415 216.837 73.6508 214.411 75.4107C215.596 82.8383 214.526 93.9652 213.586 101.924C212.61 110.189 220.986 114.007 227.345 115.706C230.951 116.668 234.597 114.294 235.207 110.609L235.211 110.613Z",
    fill: "url(#paint16_linear_2862_11635)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M173.024 87.1236C173.289 87.5007 173.562 87.8778 173.839 88.2621C180.664 97.6867 179.713 106.077 179.713 106.077C193.02 107.98 209.089 94.1417 205.289 86.1862C204.991 85.5612 204.708 84.9219 204.446 84.2754C193.927 91.7999 182.598 90.7943 173.024 87.1236Z",
    fill: "url(#paint17_linear_2862_11635)"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M356.092 51.0989C355.091 58.2247 348.51 63.9966 341.394 63.9966C334.277 63.9966 329.318 58.2212 330.316 51.0989C331.317 43.973 337.898 38.2012 345.014 38.2012C352.131 38.2012 357.09 43.9766 356.092 51.0989Z",
    fill: "#F1F2F2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M362.376 81.7041H313.916C312.875 81.7041 312.075 80.7811 312.218 79.7503L312.444 78.152C312.563 77.3043 313.288 76.6758 314.142 76.6758H362.602C363.643 76.6758 364.443 77.5988 364.3 78.6297L364.074 80.2279C363.955 81.0756 363.23 81.7041 362.376 81.7041Z",
    fill: "#F1F2F2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M360.729 93.5342H312.269C311.228 93.5342 310.428 92.6111 310.571 91.5803L310.797 89.982C310.916 89.1344 311.641 88.5059 312.495 88.5059H360.955C361.996 88.5059 362.796 89.4289 362.652 90.4597L362.426 92.058C362.308 92.9057 361.583 93.5342 360.729 93.5342Z",
    fill: "#F1F2F2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M339.944 112.212H327.1C326.06 112.212 325.259 111.289 325.403 110.258L325.629 108.66C325.747 107.812 326.472 107.184 327.326 107.184H340.17C341.211 107.184 342.011 108.107 341.867 109.137L341.641 110.736C341.523 111.583 340.798 112.212 339.944 112.212Z",
    fill: "#FFB300"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2862_11635",
    x1: 26.8176,
    y1: 85.5338,
    x2: 62.9876,
    y2: 224.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#69CDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#69C3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#68B4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#679EE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6682D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#645FC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6336B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2862_11635",
    x1: 29.0281,
    y1: 84.9555,
    x2: 65.1982,
    y2: 223.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#69CDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#69C3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#68B4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#679EE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6682D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#645FC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6336B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2862_11635",
    x1: 59.4521,
    y1: 69.5032,
    x2: 62.3099,
    y2: 219.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#69CDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#69C3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#68B4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#679EE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6682D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#645FC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6336B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2862_11635",
    x1: 85.7135,
    y1: 120.131,
    x2: 56.7812,
    y2: 202.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#69CDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#69C3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#68B4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#679EE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6682D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#645FC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6336B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2862_11635",
    x1: 326.343,
    y1: -68.0046,
    x2: 358.451,
    y2: 212.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#69CDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#69C3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#68B4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#679EE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6682D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#645FC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6336B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2862_11635",
    x1: 209.99,
    y1: 68.249,
    x2: 449.582,
    y2: 68.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#69CDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#69C3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#68B4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#679EE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6682D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#645FC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6336B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2862_11635",
    x1: 151.381,
    y1: 96.0099,
    x2: 254.83,
    y2: 54.0456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43295D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774B88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2862_11635",
    x1: 322.679,
    y1: 160.762,
    x2: 380.158,
    y2: 294.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BB68FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2862_11635",
    x1: 323.566,
    y1: 163.737,
    x2: 379.094,
    y2: 292.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BB68FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2862_11635",
    x1: 278.015,
    y1: 503.864,
    x2: 263.687,
    y2: 334.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43295D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774B88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2862_11635",
    x1: 188.48,
    y1: 511.455,
    x2: 174.152,
    y2: 342.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43295D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774B88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2862_11635",
    x1: 96.4039,
    y1: 495.941,
    x2: 161.096,
    y2: 325.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43295D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774B88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2862_11635",
    x1: 116.277,
    y1: 191.278,
    x2: 158.863,
    y2: 191.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#724CE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2862_11635",
    x1: 164.429,
    y1: 184.284,
    x2: 478.003,
    y2: 375.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#724CE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2862_11635",
    x1: 124.291,
    y1: 277.442,
    x2: 278.234,
    y2: 277.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#533AA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2862_11635",
    x1: 249.96,
    y1: 536.837,
    x2: 211.138,
    y2: 308.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43295D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774B88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2862_11635",
    x1: 217.454,
    y1: 32.9104,
    x2: 224.353,
    y2: 102.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43295D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774B88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2862_11635",
    x1: 184.235,
    y1: 34.8109,
    x2: 191.37,
    y2: 107.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43295D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774B88"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOnDesk);
export default __webpack_public_path__ + "static/media/person-on-desk.396794ec478730403dd700a9f03d56f7.svg";
export { ForwardRef as ReactComponent };